import { Highlight } from "@/interfaces/highlights";

const Highlights: Highlight[] = [
  {
    id: 0,
    name: "Music",
    icon: "music.svg",
    article:
      "Passenger Music, and mood vibes! But my playlist is basically just folk in the last few years.",
  },
  {
    id: 1,
    name: "Hobbies",
    icon: "hobbies.svg",
    article:
      "I love playing video games, watching movies, hanging out with friends, and making memories.",
  },
  {
    id: 2,
    name: "Skills",
    icon: "skills.svg",
    article:
      "Software development, front-end development, and product management.",
  },
  {
    id: 3,
    name: "Personal",
    icon: "personal.svg",
    article: "Currently based in Lagos, Nigeria.",
  },
];

export default Highlights;
